import { render, staticRenderFns } from "./listrubrik.vue?vue&type=template&id=4fff236c&"
import script from "./listrubrik.vue?vue&type=script&lang=js&"
export * from "./listrubrik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports